import { Component, Input } from '@angular/core';
import { ComponentContext } from 'src/app/modules/modal/modal.model';

@Component({
  selector: 'gcc-success-survey',
  templateUrl: './success-survey.component.html',
  styleUrls: ['./success-survey.component.scss']
})
export class SuccessSurveyComponent implements ComponentContext<any> {
  @Input() public onAction: (value: any) => void;
  @Input() public onClose: () => void;

  constructor() {
    setTimeout(() => {
      this.onCloseModal();
    }, 5000);
  }
  public onCloseModal(): void {
    this.onClose();
    this.onAction(null);
  }
}
